import * as auth from './auth.utils';
import object from './object.utils';

export default { object, auth };
